module.exports = __webpack_public_path__ + "img/1.443a3d91.png";